import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function crucigramapalabrasComboReducer(state= initialState.crucigramapalabrasCombo, action){
	switch(action.type){
		case types.GET_CRUCIGRAMAPALABRASS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}